import { assign } from './../../../../lib';
import config from './config.json';

const getConfig = env => {
  return assign({}, config[env] || config.default);
};

export default getConfig;
